<template>
    <div v-redirect-if-no-permission:LOCATIONS>
        <DataTable :url="baseUri"
                   :fieldsHiddenMain='["deleted_at","type"]'
                   :titles="titles"
                   :actionsExtraMain="actionsExtraMain"
                   :formatter="formatter"
                   :title=" (blacklist ? 'Blacklisted ' : '') + 'Areas'"/>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "Areas",
        title: 'Areas',
        props: {
            blacklist: {
                type: Boolean,
                default: false
            }
        },
        components: {DataTable},
        computed: {
            titles() {
                return {
                    "id": "#",
                    "created_at": "Date Created",
                    "updated_at": "Date Updated"
                }
            },
            baseUri() {
                if (this.blacklist)
                    return this.api.ACTIONS.BLACKLIST_LOCATIONS;
                else
                    return this.api.ACTIONS.LOCATIONS;
            },
            actionsExtraMain() {
                return {
                    edit: {
                        action: item =>
                            this.$router.push({
                                name: !this.blacklist ? "LocationsEditor" : "BlacklistLocationsEditor",
                                params: {id: item.id}
                            })
                    },
                    add: {
                        action: () =>
                            this.$router.push({name: !this.blacklist ? "LocationsAdder" : "BlacklistLocationsAdder"})
                    }
                };
            },
            formatter() {
                return {
                    polygon(polygon) {
                        let smallest = Array(2).fill(Math.pow(2, 32));
                        let biggest = Array(2).fill(-Math.pow(2, 32));
                        for (let arr of polygon.coordinates[0]) {
                            smallest[0] = Math.min(smallest[0], arr[0]);
                            smallest[1] = Math.min(smallest[1], arr[1]);
                            biggest[0] = Math.max(biggest[0], arr[0]);
                            biggest[1] = Math.max(biggest[1], arr[1]);
                        }
                        return `
                            <svg height="75" width="75" viewBox="-75 0 75 75">
                                <polygon points="${polygon.coordinates[0].map(arr => -(biggest[0] - arr[0]) / (biggest[0] - smallest[0]) * 75 + "," + (biggest[1] - arr[1]) / (biggest[1] - smallest[1]) * 75).join(" ")}" style="fill:lime;stroke:purple;stroke-width:1;"/>
                            </svg>
                        `;
                    },
                    centroid(value) {
                        return JSON.stringify(value.coordinates);
                    }
                }
            }
        }

    }
</script>

<style scoped>

</style>